import React, { Component } from "react";
import { Provider, observer } from "mobx-react";
import ApiClient from "components/ApiClient2";
import { navigate } from "@reach/router";
import { ApiContext } from "../../hooks/useApi";

class ApiProvider extends Component {
  state = {
    api: null,
  };

  componentWillMount = () => {
    this.setState({ api: new ApiClient({ url: process.env.REACT_APP_API_HOST, onError: this.onApiError }) });
  };

  onApiError = ({ status } = {}) => {
    if (status === 401) {
      navigate(`/login/?redirect=${window.location.pathname}`);
    }
  };

  render() {
    const { className } = this.props;

    return (
      <div className={[className].join(" ")}>
        <Provider api={this.state.api}>
          <ApiContext.Provider value={this.state.api}>{this.props.children}</ApiContext.Provider>
        </Provider>
      </div>
    );
  }
}

ApiProvider = observer(ApiProvider);

export default ApiProvider;
